import CreateTruckModule from 'modules/Admin/trucks/CreateTruck'

function CreateTruckPage() {
  return (
    <div data-testid="adminCreateTruckPage">
      <CreateTruckModule />
    </div>
  )
}

export default CreateTruckPage
